export default __webpack_public_path__ + "static/media/sandcastle.6b434996.ogg";